export const CREATE_RESERVATION_SCHEDULE = "CREATE_RESERVATION_SCHEDULE";
export const FETCH_RESERVATION_SCHEDULES = "FETCH_RESERVATION_SCHEDULES";
export const FETCH_RESERVATION_SCHEDULE = "FETCH_RESERVATION_SCHEDULE";
export const EDIT_RESERVATION_SCHEDULE = "EDIT_RESERVATION_SCHEDULE";
export const DELETE_RESERVATION_SCHEDULE = "DELETE_RESERVATION_SCHEDULE";
